import React, { Component } from 'react'
import { Select, InputNumber } from 'hljd'

const { Option } = Select

export default class extends Component {
  onUnitChange = value => {
    const { setFieldsValue, unitKey } = this.props
    setFieldsValue({
      [unitKey]: value
    })
  }

  render() {
    const { options, unit } = this.props

    return (
      <>
        <InputNumber
          style={{
            width: 139
          }}
          {...this.props}
        />
        {options && (
          <Select
            style={{ width: 100, marginLeft: 8 }}
            value={unit}
            onChange={this.onUnitChange}
          >
            {options.map(options => {
              const { value, text } = options
              return (
                <Option key={value} value={value}>
                  {text}
                </Option>
              )
            })}
          </Select>
        )}
        {!options && unit && <span style={{ paddingLeft: 10 }}>{unit}</span>}
      </>
    )
  }
}
